/**
 * /ai/codex 纯展示型 SSR 营销落地页，仅返回 SEO 和 CDN_HOST。
 * 同时运行在 Node 与浏览器打包环境，使用 CommonJS，禁止 import/export 与 fs/path。
 */
async function fetchData(ctx, request) {
  let cdnHost = '';
  const eggCtx = (ctx && ctx.app) ? ctx : (ctx && ctx.ctx);
  if (eggCtx && eggCtx.app && eggCtx.app.config) {
    const viewVar = eggCtx.app.config.view && eggCtx.app.config.view.variable;
    cdnHost = (viewVar && viewVar.CDN_HOST) || '';
  }
  if (!cdnHost && typeof CDN_HOST !== 'undefined') {
    cdnHost = CDN_HOST;
  }
  return {
    cdnHost: cdnHost,
    __seo: {
      title: 'CJ MCP for Codex - Manage Your Dropshipping Business with AI',
      keywords:
        'CJ MCP, Codex dropshipping, CJdropshipping MCP, Codex MCP server, AI dropshipping assistant, MCP integration',
      description:
        'Connect Codex to CJdropshipping via MCP. Search products, place orders, track shipments and manage your dropshipping business through AI conversation.',
    },
  };
}

module.exports = fetchData;
